import { ensureNumber, getAllActions } from "../comp/MissionUtils"

import { toZonedTime } from "date-fns-tz"

import { isAfter } from "date-fns/isAfter"

import { eachDayOfInterval } from "date-fns/eachDayOfInterval"

import differenceInBusinessDays from "date-fns/differenceInBusinessDays"
import { getTimesheetHoursFromTo } from "../comp/DateUtils"

import { isWithinInterval } from "date-fns"
import { getCurrencySymbol } from "../comp/Currencies"
import isWeekend from "date-fns/isWeekend"
import numeral from "numeral"
import { endOfWeek } from "date-fns/endOfWeek"
import { formatRateTimeUnits, getGreatestEndDate, getSmallestStartDate, getTimeUtc } from "../utils/dates"
import { getExchangeRates } from "../utils/exchange-rates"
import uniq from "lodash/uniq"
import flatMap from "lodash/flatMap"
import { makeHash } from "../utils/utils"
import { getAllActionItems } from "../utils/actionItem"
import { isMissionBillable as isMissionBillableUtil } from "../utils/mf-utils"
import { getActionItemCostRevenue as getActionItemCostRevenueUtil } from "../utils/mf-utils"
import { getHourlyRates as getHourlyRatesUtil } from "../utils/mf-utils"
import { getLineItemCostAndRevenue as getLineItemCostAndRevenueUtil } from "../utils/mf-utils"
import { missionFinancials as missionFinancialsUtil } from "../utils/mf-utils"
import { getRoleItemCostAndRevenue as getRoleItemCostAndRevenueUtil } from "../utils/mf-utils"
import { getRaciBudgetForRole as getRaciBudgetForRoleUtil } from "../utils/mf-utils"
import { getHoursNeedFromRaci as getHoursNeedFromRaciUtil } from "../utils/mf-utils"
import { getFxForTheDay as getFxForTheDayUtil } from "../utils/mf-utils"

export function getHoursNeedFromRaci(r, ai, from, to) {
    return getHoursNeedFromRaciUtil(r, ai, from, to)
}

export function isMissionBillable(mission) {
    return isMissionBillableUtil(mission)
}

export const updateBudgetOnRaciTasks = ({ ai, mission, app }) => {
    const myPlanItems = mission.planItems.filter((p) => {
        return ai ? p.raciOnTasks?.filter((r) => r.taskId === ai._id) : p.raciOnTasks?.length
    })

    let changesNeeded = []

    const aiHash = makeHash(getAllActionItems(mission))

    myPlanItems.forEach((pi, i) => {
        let newRacis = []
        let raciChangesMade = false

        pi.raciOnTasks?.forEach((r, i) => {
            const myAi = aiHash[r.taskId]

            const myHoursNeeded = getHoursNeedFromRaci(r, myAi)

            if (myHoursNeeded !== r.hoursNeeded) {
                newRacis.push({
                    ...r,
                    hoursNeeded: myHoursNeeded,
                })
                raciChangesMade = true
            } else {
                newRacis.push(r)
            }
        })

        if (raciChangesMade) {
            let totalHoursNeeded = ensureNumber(newRacis?.reduce((cumm, r) => (cumm += ensureNumber(r.hoursNeeded)), 0))

            changesNeeded.push({
                obj: pi,
                change: {
                    _id: pi._id,
                    raciOnTasks: newRacis,
                    hoursNeeded: totalHoursNeeded,
                },
            })
        }
    })

    if (changesNeeded.length) {
        app.planItemUpdateBulk(mission._id, changesNeeded)
    }
}

export const getDurationFromRaci = (mission, ai) => {
    const myPlanItems = mission.planItems.filter((p) => {
        return p.raciOnTasks?.filter((r) => r.taskId === ai._id)
    })
    let dur = 0
    myPlanItems.forEach((pi, i) => {
        pi.raciOnTasks?.forEach((r, i) => {
            dur += ensureNumber(getHoursNeedFromRaci(r, ai))
        })
    })

    return dur
}

export function missionFinancials(props) {
    return missionFinancialsUtil(props)
}

export function getActionPercentComplete(action) {
    const { actionItems } = action

    return (
        actionItems?.reduce((cumm, ai) => (cumm += ensureNumber(ai.percentComplete)), 0) ||
        ensureNumber(action.percentComplete)
    )
}

export function getRoleItemCostAndRevenue(props) {
    return getRoleItemCostAndRevenueUtil(props)
}

export function mapPlanItemTimesheets(pi) {
    if (!pi.timesheets?.length) {
        return []
    } else {
        return (pi.timesheets || []).map((t) => {
            return {
                ...t,
                weekStart: t.weekStart,
                weekEnd: getTimeUtc(endOfWeek(toZonedTime(t.weekStart), { weekStartsOn: 1 })),
                actionItems: [
                    {
                        days: t.dailyHours?.join(",") || "0,0,0,0,0,0,0,0",
                    },
                ],
            }
        })
    }
}

export function getLineItemCostAndRevenue({ planItem, from, to, mission, fxm }) {
    return getLineItemCostAndRevenueUtil({ planItem, from, to, mission, fxm })
}

export function getHourlyRates(planItem, raciObj) {
    return getHourlyRatesUtil(planItem, raciObj)
}

export function getMilestoneRevenue({ planItem, from, to }) {
    if (from && to && isAfter(from, to)) {
        return 0
    }

    let isInRange = !from && !to

    if (!isInRange) {
        try {
            isInRange = isWithinInterval(toZonedTime(planItem.endDate), {
                start: from,
                end: to,
            })
        } catch (e) {}
    }

    if (isInRange) {
        return ensureNumber(planItem.billRate)
    }

    return 0
}

export function getActionItemCostRevenue(props) {
    return getActionItemCostRevenueUtil(props)
}

export function getMissionHours({ mission, timesheets, from, to }) {
    let hours = {
        planned: 0,
        actual: 0,
    }

    mission.planItems
        .filter((p) => {
            return p.type === "person"
        })
        .forEach((planItem, i) => {
            const myHours = getHoursForRole({ planItem, timesheets, from, to })
            hours.planned += myHours.planned
            hours.actual += myHours.actual
        })

    return hours
}

export function formatRates({ mission, orgData, pi, type }) {
    if (!type || !pi) {
        return ""
    }

    const rate = pi[type === "cost" ? "rate" : "billRate"]

    let unit = pi[type === "cost" ? "rateTime" : "billUnit"]

    if (!unit) {
        unit = orgData.roleDefaultRateTime
    }

    if (orgData?.currency && mission.currency !== orgData.currency) {
        const cur = type === "cost" ? orgData?.currency : mission.currency
        return getCurrencySymbol(cur) + numeral(rate).format("0,0.[00]") + cur + " " + formatRateTimeUnits(unit)
    } else {
        return getCurrencySymbol(mission.currency) + numeral(rate).format("0,0.[00]") + formatRateTimeUnits(unit)
    }
}

export function getHoursForRole({ planItem, timesheets = [], from, to }) {
    let hours = {
        planned: 0,
        actual: 0,
    }

    let roleTimesheets = []

    if (timesheets.length === 0) {
        roleTimesheets = (planItem.timesheets || []).map((t) => {
            return {
                weekStart: t.weekStart,
                weekEnd: getTimeUtc(endOfWeek(toZonedTime(t.weekStart), { weekStartsOn: 1 })),
                actionItems: [
                    {
                        days: t.dailyHours?.join(",") || "0,0,0,0,0,0,0,0",
                    },
                ],
            }
        })
    } else {
        roleTimesheets = timesheets.filter((ts) => ts.planItemId === planItem._id && ts.status === "approved")
    }

    if (!from || !to) {
        from = getSmallestStartDate(roleTimesheets.map((ts) => ({ startDate: ts.weekStart })))
        to = getGreatestEndDate(
            roleTimesheets.map((ts) => ({
                endDate: getTimeUtc(endOfWeek(toZonedTime(ts.weekStart), { weekStartsOn: 1 })),
            }))
        )
    }

    hours.actual = 0

    if (planItem.raciOnTasks?.find((rt) => rt.actualHours)) {
        hours.actual = planItem.raciOnTasks?.reduce((cumm, obj) => cumm + ensureNumber(obj.actualHours), 0)
    } else {
        hours.actual = ensureNumber(getTimesheetHoursFromTo(roleTimesheets, from, to))
    }

    if (planItem.hoursNeeded || planItem.hoursNeeded === 0) {
        hours.planned = planItem.hoursNeeded || 0
    } else {
        const st = toZonedTime(planItem.startDate)
        const ed = toZonedTime(planItem.endDate)

        const d = differenceInBusinessDays(ed, st)

        hours.planned = d * 8
    }

    return hours
}

export function getCheckListCostAndRevenue(checklist) {
    let totalCost = 0
    let totalBill = 0

    checklist.forEach((st) => {
        const dur = st.actualDuration || st.duration
        totalCost += (st.rate || 0) * (dur === 0 ? 0 : dur || 1)
        totalBill += (st.billRate || 0) * (dur === 0 ? 0 : dur || 1)
    })

    return {
        estCost: totalCost,
        estRevenue: totalBill,
    }
}

export async function getExpenseTotal({ expenses, currency }) {
    let total = 0
    let rates

    if (expenses.find((ex) => ex.currency !== currency)) {
        rates = await getExchangeRates({ baseCurrency: currency })
    }

    expenses.forEach((exp, i) => {
        if (exp.status !== "approved" && exp.status !== "paid") return

        if (exp.currency !== currency) {
            const fx = rates ? rates[exp.currency] : 1
            const myTotal = ensureNumber(getExpenseAmount(exp))

            total += myTotal / fx
        } else {
            total += ensureNumber(getExpenseAmount(exp))
        }
    })

    return total
}

export function getExpenseAmount(exp, orgData) {
    let expenseAmount = ensureNumber(exp.amount)

    if (orgData?.expenseInvoiceOptions?.includes("tip")) {
        expenseAmount += ensureNumber(exp.tip)
    }
    if (orgData?.expenseInvoiceOptions?.includes("tax")) {
        expenseAmount += ensureNumber(exp.tax1) + ensureNumber(exp.tax2)
    }

    return expenseAmount
}
export function getAllChildrenThatAreActions(id, actionData) {
    let allChildren = []
    function getChildren(myId) {
        let immediateChildren = actionData.filter((d) => d.parentId === myId)
        allChildren = [...allChildren, ...immediateChildren]
        immediateChildren.forEach((item, i) => {
            getChildren(item._id)
        })
    }

    getChildren(id)

    return allChildren
}
export function getActionHours({ action, mission }) {
    const allActionKids = getAllChildrenThatAreActions(action._id, getAllActions(mission))

    const allTaskKids = [...(action.actionItems || []), ...flatMap(allActionKids, "actionItems")]

    let hours = 0

    if (allTaskKids.length === 0) {
        const d = eachDayOfInterval({
            start: toZonedTime(action.startDate),
            end: toZonedTime(action.endDate),
        }).filter((d) => !isWeekend(d)).length

        hours += d * 8
    } else {
        allTaskKids.forEach((ai, i) => {
            if (ai.actualDuration) {
                hours += ensureNumber(ai.actualDuration)
            } else {
                const d = eachDayOfInterval({
                    start: toZonedTime(ai.startDate),
                    end: toZonedTime(ai.endDate),
                }).filter((d) => !isWeekend(d)).length

                hours += ensureNumber(d * 8)
            }
        })
    }

    return ensureNumber(hours)
}

export function getBudgetForAction({ action, mission }) {
    let data = {
        estRevenue: 0,
        actualRevenue: 0,
        estCost: 0,
        actualCost: 0,
        hours: 0,
        percentComplete: 0,
    }

    const allActions = [action, ...getAllChildrenThatAreActions(action._id, getAllActions(mission))]

    const allTaskKidsForBudet = flatMap(
        allActions.filter((a) => !a.rate && !a.billRate),
        "actionItems"
    )

    allActions.forEach((ac, i) => {
        data.hours += getActionHours({ action: ac, mission })
    })

    allTaskKidsForBudet.forEach((ai, i) => {
        const b = getActionItemCostRevenue({ ai, mission })

        data.estRevenue += b.estRevenue
        data.actualRevenue += ensureNumber(Math.round(b.estRevenue * ensureNumber(ai.percentComplete / 100)))

        data.estCost += b.estCost
        data.actualCost += ensureNumber(Math.round(b.estCost * ensureNumber(ai.percentComplete / 100)))
    })

    return data
}

export const getRaciBudgetForRole = (planItem) => {
    return getRaciBudgetForRoleUtil(planItem)
}

export function getProcessTaskBudget({ ai, mission }) {
    return getActionItemCostRevenue({ ai, mission, totals: true })
}

export function getRoleRates({ role, orgData, mission }) {
    if (!role) {
        return role
    }

    if (mission.client) {
        const rc = orgData.rateCards?.find((rc) => rc.usedForId === mission.client)

        if (rc) {
            const roleRate = rc.ratesByRole.find((r) => r.roleId === role._id)

            if (roleRate) {
                return { ...role, ...roleRate, cost: roleRate.rate, _id: role._id }
            }
        }
    }

    return role
}

export function getFxForTheDay({ useMultiplier, exchangeRates, currency, day, app }) {
    return getFxForTheDayUtil({ useMultiplier, exchangeRates, currency, day, app })
}
